import React from 'react';
import {connect} from "react-redux";
import RozbalitIcon from "../../img/icons/BBiconsRozbalit";
import "./toTopButton.scss";

class ToTopButton extends React.Component {
    state = {
        visible:false,
        onBottom:false
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.scrollTop === prevProps.scrollTop) {
            return;
        }
        let newState = {...this.state};
        let changed = false;
        if(!newState.visible && this.props.scrollTop > 0) {
            newState.visible = true;
            changed = true;
        } else if (newState.visible && this.props.scrollTop <= 0) {
            newState.visible = false;
            changed = true;
        }

        if(changed) {
            this.setState(newState);
        }
    }

    render() {
        let styles = {
            marginBottom: this.state.visible ? (this.state.onBottom ? '11em' : '0') : '-11em',
            marginRight: this.props.right
        };

        return (
            <div onClick={() => window.scrollTo({top:0, behaviour:'smooth'})} className="to-top-button" style={styles}>
                <RozbalitIcon />
            </div>
        );
    }
}

export default connect(
    state => ({ layout: state.layout })
)(ToTopButton);
